import { getConfig } from 'modules/App/config';
import { DOCUMENTS_TO_REVIEW_QUERY } from 'modules/App/queries/queries';
import {
  DocumentToReview,
  ExpenseToReviewSort,
} from 'modules/Documents/models/document';
import Limits from 'types/limits';
import { buildTortillaBaseQuery } from 'utils/query/buildTortillaBaseQuery';
import request from 'utils/request';

export default async function fetchDocumentsToReview({
  page = 0,
  pageSize = Limits.SMALL,
  sortBy,
}: {
  page?: number;
  pageSize?: Limits;
  sortBy?: ExpenseToReviewSort;
}) {
  const endpoint = (await getConfig()).apiDocumentsPendingService;
  const query = buildTortillaBaseQuery({
    page,
    pageSize,
    sort: [
      {
        field: sortBy?.field,
        order: sortBy?.order,
      },
    ],
  });

  const response = await request<any>(
    `${endpoint}?${query}&query[inboxFileType]=EXPENSE`,
    {
      method: 'GET',
    }
  );
  return response?.data?.data as { items: DocumentToReview[]; count: number };
}

export const invalidateQueries = [DOCUMENTS_TO_REVIEW_QUERY];
